import { Option } from "@/types/productTypes";
import { useAdminStore } from "../../../../store/useAdminStore";
import { GenericEditor } from "@/Components/GenericEditor/GenericEditor";
import { optionConfig } from "@/configs/editorConfigs";

type OptionEditorProps = {
   option: Option;
};

export default function OptionEditor({ option }: OptionEditorProps) {
   const adminStore = useAdminStore();
   const onOptionChange = (field: keyof Option, value: any) => {
      if (
         !adminStore.selectedProductId ||
         !adminStore.selectedStageId ||
         !adminStore.selectedOptionId
      ) {
         return;
      }
      adminStore.updateOption(
         adminStore.selectedProductId,
         adminStore.selectedStageId,
         adminStore.selectedOptionId,
         field,
         value
      );
   };
   return (
      <div className="flex flex-row w-full h-full">
         <GenericEditor
            item={option}
            config={optionConfig}
            onChange={onOptionChange}
            title="Edit Option"
         />
      </div>
   );
}
